module.exports = __webpack_public_path__ + "assets/img/34_703_big.868d9d02.jpg";